import { getLoadingDataOnPageLoad as getSimilarItemsLoadingDataOnPageLoad } from "../../similarItems/selectors";
import { getLoadingDataOnPageLoad as getIsSavedItemsLoadingDataOnPageLoad } from "../../savedItems/selectors";
import getItemsType from "./getItemsType";

import { ITEMS_TYPE_SIMILAR } from "../../../../constants";

const getLoadingDataOnPageLoad = state =>
  getItemsType(state) === ITEMS_TYPE_SIMILAR
    ? getSimilarItemsLoadingDataOnPageLoad(state)
    : getIsSavedItemsLoadingDataOnPageLoad(state);

export default getLoadingDataOnPageLoad;
